import { COMPLIANCE_DUPLICATE_GROUP_BULK_TEMPLATE } from '../../../bulk-action-templates';
import type { ListBuilderList } from '../../../types';
import {
	duplicateAccountColumn,
	duplicateGroupColumn,
	duplicateLicenseColumn,
	duplicateOnFileColumn,
	reviewGroupActionColumn,
	shipToColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';
import { COMPLIANCE_ATTENTION_LIST_IDS } from '../list-ids';
import { DUPLICATE_GROUP_SORT_OPTIONS } from './duplicate-group-sort';

/**
 * Duplicate License (PD-16652, "Check Your Records") — the same license
 * twice on ONE account, where the customer's ERP holds every copy (two or
 * more ERP ids). Workd cannot edit ERP license records, so the customer fixes
 * these in their ERP; copies only Workd holds never appear (Workd removes
 * them). Also the same number on one account under two different types — a
 * number keyed into the wrong field — with its own sentence.
 *
 * One row per copy, a group's copies together, groups whose copies disagree
 * on the expiration date first. NOT locked to active buyers: a duplicate on
 * any customer account is the customer's to fix.
 *
 * COUNT PARITY. The locked `licenseDuplicateLicense: yes` resolves to the
 * member ids of the SAME groups the dashboard card counts
 * (`LicenseDuplicateGroupService`), net of the same reviews. The card counts
 * GROUPS; the list shows their rows.
 */
export const duplicateLicenseList: ListBuilderList = {
	id: COMPLIANCE_ATTENTION_LIST_IDS.duplicateLicense,
	cacheTTL: 300000,
	name: 'Duplicate',
	type: 'default',
	active: true,
	// After the One Click lists, as on the dashboard; 13 is its Reviewed view.
	sortOrder: 13,
	filterRules: {
		...hideOtherCardFilters(['licenseDuplicateLicense']),
		licenseDuplicateLicense: {
			defaultValue: [{ id: 'yes', label: 'Same license twice on one account' }],
			locked: true,
		},
	},
	columns: [
		duplicateGroupColumn,
		duplicateAccountColumn,
		shipToColumn,
		duplicateLicenseColumn,
		duplicateOnFileColumn,
		whyHereColumn,
		reviewGroupActionColumn,
	],
	sortOptions: DUPLICATE_GROUP_SORT_OPTIONS,
	defaultSortId: 'group-risk',
	// PD-16654: select several groups, record one outcome and note for all.
	bulkActionTemplate: COMPLIANCE_DUPLICATE_GROUP_BULK_TEMPLATE,
};
